import { ClientObject, PropertyInit } from '../common/clientObject';
import { MailItem } from './mailItem';
import { RequestType, ValueType } from '../comObject';

export class Selection extends ClientObject implements PropertyInit {
    private properties = this.clientObjectInitPropsInfo({
        count: { propertyName: 'count', name: 'Count' },
        class: { propertyName: 'class', name: 'Class' },
    });

    public getPropertyInitializers(): Map<keyof Selection, () => void> {
        return new Map<keyof Selection, () => void>(
            Object.values(this.properties).map(({ propertyName, name }) => [
                propertyName,
                (): void =>
                    this.reference.request({
                        type: RequestType.GetProperty,
                        cacheName: propertyName,
                        name,
                    }),
            ]),
        );
    }

    public get count(): number {
        return this.reference.getValue<number>(this.properties.count.propertyName).value;
    }

    public get class(): number {
        return this.reference.getValue<number>(this.properties.class.propertyName).value;
    }

    public getItem(index: number): MailItem {
        return this.reference.requestObject({
            type: RequestType.GetProperty,
            creator: MailItem,
            name: 'Item',
            args: [{ value: index, type: ValueType.Integer }],
        }).value;
    }
}
